import axiosInstance from 'api/axios';
import { APIResponse } from '../types';

interface scheduleBlogApiResponse {
  success: boolean;
  message: string;
}

const schedulingService = {
  // schedule blog on linkedin
  scheduleBlog: async (data: {
    blog_id: string | null;
    scheduled_at: string;
  }): Promise<APIResponse<scheduleBlogApiResponse>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/linkedin/blogs/schedule',
      data
    );

    return response.data;
  },

  // editing scheduled blog's time
  editScheduledBlog: async (updateData: {
    blog_id: number;
    scheduled_at: string;
  }): Promise<APIResponse<scheduleBlogApiResponse>> => {
    const response = await axiosInstance.private.put(
      '/api/v1/linkedin/blogs/scheduled',
      updateData
    );

    return response.data;
  },

  // deleting scheduled blog
  deleteScheduledBlog: async (
    blogId: number
  ): Promise<APIResponse<scheduleBlogApiResponse>> => {
    const response = await axiosInstance.private.delete(
      `/api/v1/linkedin/blogs/scheduled/${blogId}`
    );

    return response.data;
  },
};

export default schedulingService;
